import { Component, OnInit } from '@angular/core';
import {
    CommonComponent,
    CommonElementsConfig,
} from '../common/common.component';

@Component({
    selector: 'app-dialog-ledger-payment',
    templateUrl: '../common/common.component.html',
    styleUrls: ['../common/common.component.css'],
})
export class PaymentComponent extends CommonComponent implements OnInit {
    public override elements = new CommonElementsConfig([
        'amount',
        'comment',
        'referenceId',
        'receiverEmail',
    ]);

    public override submitLabel = 'Send Payment';
    public override headingLabel = 'Send a Payment';

    public override submit() {
        let payload = {
            receiver_email: this.formGroup.get('receiverEmail')!.value,
            reference_id: this.formGroup.get('referenceId')!.value,
            reference_type: 'DIRECT',
            amount: Number(this.formGroup.get('amount')!.value),
            comment: this.formGroup.get('comment')!.value,
        };

        this.sendPayload('ledger/payment', payload);
    }
}
